/**
 * Navigation scripts
 * @author Oliver Boermans
 * @author Rhys Lloyd
 */

//
// Dependencies
import toggle from './toggle';
import geolocationButton from './geolocation-button';
import mapViewButton from './map-view-button';
import searchFilterToggle from './search-filter-toggle';

export default function exec () {
	toggle();
	geolocationButton();
	mapViewButton();
	searchFilterToggle();
}




// WEBPACK FOOTER //
// ./project/client/src/core/modules/navigation/index.js